var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard"}},[_c('nprogress-container'),_c('Menu'),_c('FlashMessage',{attrs:{"position":'right top'}}),_c('div',{staticClass:"container-fluid app-body"},[_c('div',{staticClass:"card-body rounded-0 border"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }